import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedDate } from 'react-intl';

import { InspectionRequest } from '../../../../../graphql/generated/graphql';
import { toJSDate } from '../../../../../utility/graphql/datetime';
import { SPACING_LARGE, SPACING_REGULAR } from '../../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../../styleUtility/flexibleLayout';
import AvatarWithName from '../../../primitive/AvatarWithName';
import InspectionModificationRequestItem from './InspectionModificationRequestItem';

interface Props {
  inspectionModificationRequest: InspectionRequest;
  index: number;
  className?: string;
}

const InspectionModificationRequestDetail = ({
  inspectionModificationRequest,
  index,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const items = inspectionModificationRequest.items.map((item, i) => <Item item={item} key={i} />);

  return (
    <div className={className}>
      <TitleBar>
        <Title>
          <FormattedMessage id="inspection_modification_request.title" /> #{index + 1}
        </Title>
        <AvatarWithName name="KaizenCS" imageUrl="/assets/kaizen_logo_icon.png" small />
        {inspectionModificationRequest.createdAt ? (
          <UpdateDateTime>
            <FormattedDate
              year="numeric"
              month="long"
              day="2-digit"
              hour="2-digit"
              minute="2-digit"
              value={toJSDate(inspectionModificationRequest.createdAt)}
            />
          </UpdateDateTime>
        ) : null}
      </TitleBar>
      <Description>
        <FormattedMessage id="inspection_modification_request.description" />
      </Description>
      {items}
    </div>
  );
};

const TitleBar = styled('div')({
  ...flexibleLayoutContainer({ alignItems: 'center' }),
  marginBottom: SPACING_REGULAR,
});

const Title = styled(Typography)({ marginRight: SPACING_REGULAR });
Title.defaultProps = { variant: 'h6' };

const UpdateDateTime = styled(Typography)({ marginLeft: SPACING_REGULAR });
UpdateDateTime.defaultProps = { variant: 'caption' };

const Description = styled(Typography)({ marginBottom: SPACING_LARGE });

const Item = styled(InspectionModificationRequestItem)({
  marginBottom: SPACING_REGULAR,
  ':last-child': {
    marginBottom: 0,
  },
});

export default InspectionModificationRequestDetail;
